import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PermissionService } from 'app/shared/services/permission.service';
import { SharedModule } from 'app/shared/shared.module';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { PermissionsRoutingModule } from './permissions-routes.module';
import { PermissionsNavigatorHelper } from './permissions-navigator-helper';
import { PermissionFacade } from 'app/shared/services/facades/permission.facade';
import { PermissionEntityResolver } from 'app/shared/components/entity-resolvers/permission.entity-resolver';
import { PermissionsLayoutComponent } from './overview/layout/permissions-layout.component';
import { PermissionsOverviewComponent } from './overview/overview/permissions-overview.component';
import { PermissionsSidepanelComponent } from './overview/sidepanel/permissions-sidepanel.component';
import { PermissionDetailsComponent } from './detail/permission-details.component';
import { PermissionDetailsGeneralComponent } from './detail/permission-details-general.component';
import { PermissionDetailsPermissionsetsComponent } from './detail/permission-details-permissionsets.component';
import { PermissionDetailsRolesComponent } from './detail/permission-details-roles.component';
import { PermissionDetailsUsersComponent } from './detail/permission-details-users.component';

@NgModule({
  declarations: [
    PermissionsLayoutComponent,
    PermissionsOverviewComponent,
    PermissionsSidepanelComponent,
    PermissionDetailsComponent,
    PermissionDetailsGeneralComponent,
    PermissionDetailsPermissionsetsComponent,
    PermissionDetailsRolesComponent,
    PermissionDetailsUsersComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    PermissionsRoutingModule,
    SelectButtonModule,
    TreeModule,
    DropdownModule,
  ],
  exports: [
    PermissionsLayoutComponent,
    PermissionsOverviewComponent,
    PermissionsSidepanelComponent,
    PermissionDetailsComponent,
    PermissionDetailsGeneralComponent,
    PermissionDetailsPermissionsetsComponent,
    PermissionDetailsRolesComponent,
    PermissionDetailsUsersComponent,
  ],
  providers: [PermissionFacade, PermissionService, PermissionsNavigatorHelper, PermissionEntityResolver],
})
export class PermissionsModule {}
